import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import ExchangeMembersReportTable from "./ExchangeMembersReportTable";
import { usePageStyles } from "../../pageStyles";
import { PageComponent } from "../../../core/navigation/types";
import { PageTitle } from "../../components/common/PageTitle";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";
import { ExchangeMemberReportFilter } from "./ExchangeMemberReportFilter";

const ExchangeMembersReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exmemTitle" />}
              action={<ExchangeMembersReportActions />}
            />
            <Divider />
            <CardContent>
              <ExchangeMembersReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const ExchangeMembersReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <ExchangeMemberReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default ExchangeMembersReport;
